<template>
    <div class="bg-bluish">
        <!-- HERO -->
        <section class="relative min-h-screen overflow-hidden bg-[#050505] text-white">
            <!-- background -->
            <div class="absolute inset-0">
                <div
                    class="h-full w-full bg-[url('@img/backgrounds/pattern-5.webp')] bg-cover bg-top"
                ></div>

                <div class="absolute inset-0 bg-black/70"></div>

                <div
                    class="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,196,0,0.16),transparent_28%),radial-gradient(circle_at_85%_18%,rgba(255,196,0,0.12),transparent_22%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.04),transparent_26%)]"
                ></div>

                <div
                    class="absolute -left-24 top-24 h-[260px] w-[260px] rounded-full bg-baseColor/10 blur-3xl"
                ></div>
                <div
                    class="absolute right-[-80px] top-[-40px] h-[260px] w-[260px] rounded-full bg-baseColor/10 blur-3xl"
                ></div>

                <div class="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#0d141b] to-transparent"></div>
            </div>

            <div class="relative container flex min-h-screen flex-col justify-center pt-[90px] pb-[40px] md:pt-20">
                <div class="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-10">
                    <!-- left -->
                    <div class="lg:col-span-7">
                        <Breadcrumbs theme="dark"/>
                        <div
                            class="mb-2 inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-4 py-2"
                        >
                            <span class="h-2 w-2 rounded-full bg-baseColor shadow-[0_0_18px_rgba(255,196,0,0.8)]"></span>
                            <p class="text-xs font-semibold uppercase tracking-[0.14em] text-white/65">
                                Разработка под задачи бизнеса
                            </p>
                        </div>

                        <h1
                            class="max-w-4xl text-2xl font-extrabold leading-[1.04] tracking-[-0.04em] md:text-4xl"
                        >
                            Разработка
                            <span class="text-baseColor">цифровых решений</span>
                            для роста и автоматизации
                        </h1>

                        <p
                            class="quote mt-6 max-w-3xl text-xs leading-[1.5] text-white/82 md:text-sm lg:text-[15px]"
                        >
                            Проектируем и разрабатываем сайты, личные кабинеты, CRM,
                            внутренние системы, интеграции и инструменты автоматизации.
                            Помогаем бизнесу упростить процессы, сократить ручную работу
                            и получить управляемую цифровую инфраструктуру.
                        </p>

                        <div class="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
                            <div
                                class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75"
                            >
                                <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                                CRM и внутренние системы
                            </div>

                            <div
                                class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75"
                            >
                                <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                                Интеграции и автоматизация
                            </div>

                            <div
                                class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75"
                            >
                                <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                                Сайты и веб-платформы
                            </div>
                        </div>

                        <div class="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
                            <div
                                @click.prevent="callbackStore.showBaseCallbackPopup({ title: 'Разработка и интеграции', description: 'Разработка и интеграции' })"
                                class="inline-flex h-[54px] w-full cursor-pointer items-center justify-center rounded-2xl bg-baseColor px-6 text-[16px] font-bold text-black shadow-[0_12px_40px_rgba(255,196,0,0.22)] transition hover:-translate-y-0.5 hover:bg-[#e6b000] sm:w-auto sm:min-w-[230px]"
                            >
                                Оставить заявку
                            </div>

                            <div class="flex items-center gap-3 text-sm text-white/55">
                                <span class="h-px w-10 bg-white/15"></span>
                                Разбор задачи и архитектуры решения
                            </div>
                        </div>

                        <div class="max-md:hidden mt-12 grid max-w-[820px] grid-cols-1 gap-4 sm:grid-cols-3">
                            <div
                                v-for="(metric, index) in heroMetrics"
                                :key="metric.title"
                                class="group relative overflow-hidden rounded-[24px] border border-white/10 bg-white/[0.04] p-5 transition duration-300 hover:-translate-y-1 hover:border-baseColor/30 hover:bg-white/[0.06]"
                            >
                                <div
                                    class="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-baseColor/70 to-transparent"
                                ></div>

                                <div class="text-[34px] font-extrabold leading-none text-baseColor">
                                    {{ String(index + 1).padStart(2, '0') }}
                                </div>

                                <p class="mt-3 text-[15px] leading-[1.5] text-white/82">
                                    {{ metric.title }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- right -->
                    <div class="lg:col-span-5">
                        <div class="relative">
                            <div
                                class="absolute -inset-3 rounded-[34px] bg-gradient-to-br from-baseColor/15 via-transparent to-white/5 blur-2xl"
                            ></div>

                            <div
                                class="relative overflow-hidden rounded-[32px] border border-white/10 bg-white/[0.05] backdrop-blur-sm p-4"
                            >
                                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
                                    <div
                                        v-for="card in heroCards"
                                        :key="card.label"
                                        class="group relative overflow-hidden rounded-[26px] border border-white/10 bg-white/[0.04] p-6 transition duration-300 hover:border-baseColor/25 hover:bg-white/[0.06]"
                                    >
                                        <div
                                            class="absolute right-0 top-0 h-24 w-24 rounded-full bg-baseColor/10 blur-2xl transition duration-300 group-hover:bg-baseColor/15"
                                        ></div>

                                        <div class="relative">
                                            <div
                                                class="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/42"
                                            >
                                                {{ card.label }}
                                            </div>

                                            <div
                                                class="mt-3 text-[22px] font-extrabold leading-[1.2] text-white"
                                            >
                                                {{ card.title }}
                                            </div>

                                            <div class="mt-5 flex items-center gap-2">
                                                <div class="h-2 w-2 rounded-full bg-baseColor"></div>
                                                <div class="h-px flex-1 bg-white/10"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-4 rounded-[26px] border border-white/10 bg-black/20 p-5">
                                    <div class="flex items-center justify-between gap-4">
                                        <div>
                                            <div class="text-xs uppercase tracking-[0.14em] text-white/38">
                                                Фокус
                                            </div>
                                            <div class="mt-2 max-w-md text-xs leading-[1.5] text-white/72 md:text-sm">
                                                Не просто сделать интерфейс, а
                                                выстроить рабочий инструмент:
                                                понятную логику, стабильную архитектуру,
                                                интеграции, масштабируемость и эффект для бизнеса.
                                            </div>
                                        </div>

                                        <div
                                            class="hidden min-w-[72px] rounded-2xl border border-baseColor/20 bg-baseColor/10 px-3 py-4 text-center md:block"
                                        >
                                            <div class="text-xs uppercase tracking-[0.12em] text-white/35">
                                                TECH
                                            </div>
                                            <div class="mt-1 text-lg font-extrabold text-baseColor">
                                                MVP
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /right -->
                </div>
            </div>
        </section>

        <!-- ЧТО ДАЁТ -->
        <section class="relative overflow-hidden py-10 md:py-20">
            <div class="absolute inset-0 opacity-50">
                <img
                    src="@img/backgrounds/pattern-2.webp"
                    alt=""
                    class="h-full w-full object-cover"
                />
            </div>

            <div class="relative container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Системный подход к цифровой разработке
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Что даёт разработка под бизнес
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="item in benefits"
                        :key="item.title"
                        class="rounded-[28px] bg-white p-7 shadow-sm"
                    >
                        <div class="mb-6 flex items-center gap-4">
                            <div class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-bluish">
                                <span class="block h-3.5 w-3.5 rounded-full bg-baseColor"></span>
                            </div>

                            <h3 class="text-[22px] font-extrabold leading-[1.25] text-[#173047]">
                                {{ item.title }}
                            </h3>
                        </div>

                        <p class="text-sm leading-[1.5] text-[#587086] md:text-[15px]">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ПРЕИМУЩЕСТВА -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Наши преимущества
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
                    <div
                        v-for="(item, index) in advantages"
                        :key="item.title"
                        class="rounded-[28px] bg-white bg-center bg-no-repeat p-7 shadow-sm"
                        style="background-image: url('@img/backgrounds/pattern-2.webp');"
                    >
                        <div class="mb-5 flex items-center gap-4">
                            <div
                                class="flex h-[58px] min-w-[58px] items-center justify-center rounded-full bg-baseColor text-2xl font-extrabold text-black"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>

                            <h3 class="pt-1 text-base font-extrabold leading-[1.35] text-[#20262d] md:text-lg">
                                {{ item.title }}
                            </h3>
                        </div>

                        <p class="text-sm leading-[1.5] text-[#6b7d8e] md:text-[15px]">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ЧТО ВХОДИТ -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Аналитика, проектирование, реализация и запуск
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Что входит в услугу
                    </h2>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="item in included"
                        :key="item.title"
                        class="rounded-[28px] bg-white p-7 shadow-sm"
                    >
                        <div class="mb-6 flex items-center gap-4">
                            <div class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-bluish">
                                <span class="block h-3.5 w-3.5 rounded-full bg-baseColor"></span>
                            </div>

                            <h3 class="text-[22px] font-extrabold leading-[1.25] text-[#173047]">
                                {{ item.title }}
                            </h3>
                        </div>

                        <p class="text-sm leading-[1.5] text-[#587086] md:text-[15px]">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ЭТАПЫ -->
        <section class="bg-white py-10 md:py-20">
            <div class="container">
                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Как проходит работа
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-5">
                    <div
                        v-for="(step, index) in steps"
                        :key="step.title"
                        class="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-[#dfe6ec] bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-baseColor/30 hover:shadow-md"
                    >
                        <div class="absolute inset-x-0 top-0 h-1 bg-baseColor/90"></div>

                        <div
                            class="absolute right-0 top-0 h-24 w-24 rounded-full bg-baseColor/10 blur-2xl transition duration-300 group-hover:bg-baseColor/15"
                        ></div>

                        <div class="relative">
                            <div
                                class="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-baseColor/10 text-2xl font-extrabold leading-none tracking-tight text-baseColor"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>
                        </div>

                        <h3
                            class="relative mt-5 text-lg font-extrabold leading-tight text-[#172f45] md:text-xl"
                        >
                            {{ step.title }}
                        </h3>

                        <p class="relative mt-3 text-sm leading-[1.5] text-[#63788b]">
                            {{ step.text }}
                        </p>

                        <div class="mt-auto flex items-center gap-2 pt-4">
                            <div class="h-1.5 w-1.5 rounded-full bg-baseColor"></div>
                            <div class="h-px flex-1 bg-[#e3e8ee]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ПРОБЛЕМЫ -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Задачи, которые закрывает разработка
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Какие проблемы решаем
                    </h2>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="item in problems"
                        :key="item"
                        class="rounded-[28px] bg-white p-7 shadow-sm"
                    >
                        <div class="mb-6 flex items-center gap-4">
                            <div class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-bluish">
                                <span class="block h-3.5 w-3.5 rounded-full bg-baseColor"></span>
                            </div>

                            <h3 class="text-[22px] font-extrabold leading-[1.25] text-[#173047]">
                                Задача бизнеса
                            </h3>
                        </div>

                        <p class="text-sm leading-[1.5] text-[#587086] md:text-[15px]">
                            {{ item }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- CTA -->
        <section class="bg-white py-10 md:pb-20">
            <div class="container">
                <div
                    class="relative overflow-hidden rounded-3xl bg-bluish bg-[url('@img/backgrounds/pattern-2.webp')] bg-cover bg-center bg-no-repeat shadow-xl"
                >
                    <div
                        class="relative grid grid-cols-1 gap-8 px-6 py-8 md:px-10 md:py-10 lg:grid-cols-[minmax(0,1.4fr)_auto] lg:items-center lg:gap-10 xl:px-12"
                    >
                        <div class="max-w-3xl">
                            <h2 class="text-2xl font-extrabold leading-tight tracking-tight text-[#173047] md:text-3xl lg:text-4xl">
                                Готовы разработать систему под ваш бизнес?
                            </h2>

                            <p class="mt-4 max-w-2xl text-sm leading-[1.5] text-[#5f7385] md:text-base">
                                Разберём задачу, предложим архитектуру, стек, этапы реализации и понятный
                                сценарий запуска — от первого MVP до масштабируемой рабочей системы.
                            </p>
                        </div>

                        <div class="flex lg:justify-end">
                            <button
                                @click.prevent="callbackStore.showBaseCallbackPopup({ title: 'Разработка и интеграции', description: 'Разработка и интеграции' })"
                                class="inline-flex h-14 w-full items-center justify-center rounded-2xl bg-baseColor px-6 text-sm font-bold uppercase tracking-wide text-black shadow-md transition hover:bg-baseColor/80 hover:shadow-lg sm:w-auto sm:min-w-72"
                            >
                                Оставить заявку
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { useCallbackStore } from "@js/store/CallbackStore.js";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

const callbackStore = useCallbackStore();

const heroMetrics = [
    {
        title: 'Автоматизируйте ключевые процессы компании',
    },
    {
        title: 'Сокращайте ручную работу и количество ошибок',
    },
    {
        title: 'Получайте систему, которую можно масштабировать',
    },
];

const heroCards = [
    {
        label: 'Разработка',
        title: 'Сайты, платформы, личные кабинеты и внутренние системы',
    },
    {
        label: 'Интеграции',
        title: 'CRM, API, платёжные сервисы, мессенджеры и сторонние сервисы',
    },
    {
        label: 'Автоматизация',
        title: 'Оптимизация процессов, уведомления, очереди и бизнес-логика',
    },
];

const benefits = [
    {
        title: 'Меньше ручной работы',
        text: 'Автоматизируем рутинные действия, чтобы команда тратила меньше времени на повторяющиеся операции и ошибки.',
    },
    {
        title: 'Быстрее процессы',
        text: 'Цифровые инструменты ускоряют обработку заявок, работу менеджеров, обмен данными и внутренние согласования.',
    },
    {
        title: 'Понятный контроль',
        text: 'Система даёт прозрачность по задачам, статусам, обращениям, клиентам, документам и другим важным процессам.',
    },
    {
        title: 'Интеграция данных',
        text: 'Соединяем сайт, CRM, аналитику, телефонию, ботов, платёжные решения и другие сервисы в единую экосистему.',
    },
    {
        title: 'Гибкость под бизнес',
        text: 'Решение проектируется под реальные процессы компании, а не заставляет команду подстраиваться под чужие ограничения.',
    },
    {
        title: 'Масштабируемость',
        text: 'Закладываем архитектуру, которая подходит не только для текущих задач, но и для роста нагрузки, команды и функциональности.',
    },
];

const advantages = [
    {
        title: 'Смотрим на проект как на инструмент бизнеса',
        text: 'Для нас разработка — это не просто код и интерфейс, а рабочая система, которая должна давать измеримый эффект в процессах и продажах.',
    },
    {
        title: 'Продумываем архитектуру и логику заранее',
        text: 'Перед реализацией разбираем роли, сценарии, данные, интеграции и будущий рост системы, чтобы не собирать всё хаотично по ходу.',
    },
    {
        title: 'Делаем решения, которые можно развивать',
        text: 'Проектируем продукт так, чтобы его можно было дополнять новыми модулями, сервисами, автоматизациями и интерфейсами без боли.',
    },
];

const included = [
    {
        title: 'Анализ задачи и процессов',
        text: 'Разбираем, как сейчас работает бизнес, где узкие места, что нужно автоматизировать и какие функции действительно важны.',
    },
    {
        title: 'Проектирование структуры',
        text: 'Формируем архитектуру решения, роли пользователей, сценарии работы, сущности данных и общую логику системы.',
    },
    {
        title: 'Разработка интерфейсов',
        text: 'Создаём удобные страницы, кабинеты, панели управления, формы, таблицы и другие элементы пользовательского взаимодействия.',
    },
    {
        title: 'Backend и бизнес-логика',
        text: 'Реализуем серверную часть, права доступа, сценарии обработки данных, очереди задач, уведомления и внутреннюю логику проекта.',
    },
    {
        title: 'Интеграции и автоматизация',
        text: 'Подключаем CRM, платёжные системы, API, почту, мессенджеры, аналитику, телефонию и другие внешние сервисы.',
    },
    {
        title: 'Тестирование и запуск',
        text: 'Проверяем стабильность, устраняем критичные риски, подготавливаем систему к запуску и сопровождаем внедрение.',
    },
];

const steps = [
    {
        title: 'Погружение в задачу',
        text: 'Изучаем бизнес, текущие процессы, ограничения, цели проекта и определяем, какое решение действительно нужно компании.',
    },
    {
        title: 'Проектирование решения',
        text: 'Определяем состав модулей, логику системы, архитектуру, интеграции, роли, этапы и приоритеты разработки.',
    },
    {
        title: 'Разработка MVP или основного ядра',
        text: 'Собираем базовый рабочий продукт, который уже можно тестировать на реальных сценариях и постепенно развивать.',
    },
    {
        title: 'Интеграции и доработка',
        text: 'Подключаем внешние сервисы, усиливаем автоматизацию, закрываем дополнительные процессы и улучшаем удобство работы.',
    },
    {
        title: 'Запуск и развитие',
        text: 'Выводим решение в рабочий контур, отслеживаем использование, собираем обратную связь и масштабируем систему дальше.',
    },
];

const problems = [
    'Процессы внутри компании держатся на таблицах, переписках и ручной передаче информации.',
    'Менеджеры, отделы и сервисы работают разрозненно, из-за чего теряются данные и замедляется работа.',
    'Нет единой системы для клиентов, заявок, документов, задач или внутренних операций.',
    'Текущие инструменты не подходят под специфику бизнеса и ограничивают развитие.',
    'Нужно связать сайт, CRM, ботов, аналитику, оплату и другие сервисы в единую логику.',
    'Компания растёт, а цифровая инфраструктура не успевает за масштабом и нагрузкой.',
];
</script>
